module.exports = __webpack_public_path__ + "img/apk.06a2c3fb.svg";